const REQUESTOR_METRICS = [
  {
    label: 'Decisions due today',
    value: '3',
    detail: 'High-risk - open them first',
    icon: 'bi-exclamation-triangle',
    detail_class: 'text-danger'
  },
  {
    label: 'SLA warning',
    value: '11',
    detail: '<= 48hr to breach',
    icon: 'bi-clock-history',
    detail_class: 'secondary-color'
  },
  {
    label: 'Awaiting evidence',
    value: '7',
    detail: 'Claimant requested',
    icon: 'bi-file-earmark-text',
    detail_class: 'secondary-color'
  },
  {
    label: 'Hours this week',
    value: '18.4',
    detail: 'Target 35h',
    icon: 'bi-stopwatch',
    detail_class: 'text-purple'
  }
];

const REQUESTOR_PRIORITY_QUEUE = [
  {
    case_code: 'C-2026-0142',
    title: 'Suspicious motor claim - payout pending review',
    meta: 'C-2026-0142 - Claims - R 142,800 - Risk 81 (High)',
    chip: 'Decision overdue 8h',
    chip_tone: 'danger',
    accent_tone: 'danger',
    action_label: 'Decide'
  },
  {
    case_code: 'C-2026-0137',
    title: 'Procurement irregularity - tender award',
    meta: 'C-2026-0137 - Oversight - R 4.8M tender - Risk 76 (High)',
    chip: 'Inspector report in',
    chip_tone: 'danger',
    accent_tone: 'danger',
    action_label: 'Review'
  },
  {
    case_code: 'C-2026-0139',
    title: 'Wrongful eviction - Diepsloot',
    meta: 'C-2026-0139 - Legal - Thandiwe Mokoena - Risk 72 (High)',
    chip: '36h to SLA breach',
    chip_tone: 'warning',
    accent_tone: 'warning',
    action_label: 'Triage'
  },
  {
    case_code: 'C-2026-0135',
    title: 'Hospital billing dispute - duplicate codes',
    meta: 'C-2026-0135 - Claims - R 87,400 - ICD overlap flagged',
    chip: 'New evidence',
    chip_tone: 'success',
    accent_tone: 'success',
    action_label: 'Open'
  },
  {
    case_code: 'C-2026-0136',
    title: 'Discrimination grievance - Cape Town branch',
    meta: 'C-2026-0136 - HR - Employee EM-7741 - Risk 54 (Mid)',
    chip: 'Awaiting your note',
    chip_tone: 'success',
    accent_tone: 'success',
    action_label: 'Respond'
  }
];

const REQUESTOR_ACTIVITY = [
  {
    dot_class: 'bg-danger',
    meta: '08:14 - System',
    text: 'SLA breached on C-2026-0142 - coordinator notified.'
  },
  {
    dot_class: 'bg-warning',
    meta: 'Yesterday 14:42 - Rule Engine',
    text: 'R-CL-014 fired on C-2026-0142 - risk 54 -> 81.'
  },
  {
    dot_class: 'bg-success',
    meta: 'Yesterday 11:08 - N. Mokwena',
    text: 'Uploaded 4 documents to C-2026-0142.'
  },
  {
    dot_class: 'bg-success',
    meta: 'Yesterday 09:30 - P. Maboe',
    text: 'Coordinator note added to C-2026-0142.'
  },
  {
    dot_class: 'bg-secondary-subtle',
    meta: '10 May 15:30 - System',
    text: 'Portfolio match on C-2026-0142 found 2 prior claims.'
  },
  {
    dot_class: 'bg-success',
    meta: '10 May 10:30 - Portal',
    text: 'New claim filed by J. Mokwena - auto-routed to you.'
  }
];

const REQUESTOR_INFO_CALLOUT = 'X-VERDICT ships as a generic case engine. Categories, role labels and workflows are per-tenant configuration on the same shell.';

export default {
  name: 'RequestorDashboard',
  computed: {
    current_user_name() {
      return String(this.$store.getters.currentLeadName || 'Sundeep').trim();
    },
    greeting_title() {
      return `Good morning, ${this.current_user_name}.`;
    },
    summary_segments() {
      return [
        { text: 'You have ' },
        { text: '3 cases needing a decision today', strong: true },
        { text: ', ' },
        { text: '11 SLA warnings', strong: true },
        { text: ', and ' },
        { text: '2 inspector reports', strong: true },
        { text: ' waiting in your queue.' }
      ];
    },
    metrics() {
      return REQUESTOR_METRICS;
    },
    queue_items() {
      return REQUESTOR_PRIORITY_QUEUE;
    },
    activity_items() {
      return REQUESTOR_ACTIVITY;
    },
    info_callout() {
      return REQUESTOR_INFO_CALLOUT;
    }
  },
  methods: {
    go_to_case_detail(case_code) {
      this.$router.push({ name: 'ViewCaseDetails', params: { caseCode: case_code } });
    },
    go_to_queue() {
      this.$router.push({ name: 'OwnerQueue' });
    }
  }
};
